<template>
  <div v-if="visible" class="match-loading" @touchmove.prevent>
    <img
      class="match-loading__gif"
      src="../../../public/img/register/register_tl12/match_loading.gif"
      alt=""
    />
    <span class="match-loading__title">额度评估</span>
    <span class="match-loading__status">正在检测：{{ currentStepLabel }}</span>

    <div class="match-loading__list">
      <div v-for="item in steps" :key="item.label" class="match-loading__item">
        <span class="match-loading__label">{{ item.label }}</span>
        <div
          class="match-loading__icon"
          :class="'match-loading__icon--' + item.status"
        >
          <div
            v-if="item.status === 'loading'"
            class="match-loading__spinner"
          ></div>
          <img
            v-else-if="item.status === 'done'"
            class="match-loading__check-icon"
            src="../../../public/img/register/register_tl12/check_icon.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const MATCH_STEPS = ["基本信息检测", "风控检测", "匹配资方检测"];
const STEP_DURATION = 1500;

function createInitialSteps() {
  return MATCH_STEPS.map((label, index) => ({
    label,
    status: index === 0 ? "loading" : "pending",
  }));
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export default {
  name: "MatchLoading",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      steps: createInitialSteps(),
      currentStepLabel: MATCH_STEPS[0],
      running: false,
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.startAnimation();
          return;
        }
        this.running = false;
        this.resetSteps();
      },
    },
  },
  beforeDestroy() {
    this.running = false;
  },
  methods: {
    resetSteps() {
      this.steps = createInitialSteps();
      this.currentStepLabel = MATCH_STEPS[0];
    },

    async startAnimation() {
      if (this.running) return;

      this.running = true;
      this.resetSteps();

      for (let i = 0; i < MATCH_STEPS.length; i++) {
        if (!this.running) return;

        await sleep(STEP_DURATION);

        this.steps = this.steps.map((step, index) => {
          if (index <= i) return { ...step, status: "done" };
          if (index === i + 1) return { ...step, status: "loading" };
          return { ...step, status: "pending" };
        });
        this.currentStepLabel =
          i < MATCH_STEPS.length - 1 ? MATCH_STEPS[i + 1] : MATCH_STEPS[i];
      }

      if (!this.running) return;

      this.running = false;
      this.$emit("finish");
    },
  },
};
</script>

<style lang="scss" scoped>
.match-loading {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 0.32rem 0.48rem;
  box-sizing: border-box;
  background-color: #ffffff;
}

.match-loading__gif {
  width: 3.33rem;
  height: 3.21rem;
}

.match-loading__title {
  margin-top: 0.48rem;
  font-size: 0.32rem;
  color: #333333;
  font-weight: 600;
}

.match-loading__status {
  margin-top: 0.16rem;
  margin-bottom: 0.64rem;
  font-size: 0.28rem;
  color: #999999;
}

.match-loading__list {
  width: 2.6rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.match-loading__item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.24rem;
  width: 3.48rem;
  margin-bottom: 0.4rem;
}

.match-loading__item:last-child {
  margin-bottom: 0;
}

.match-loading__label {
  width: 2.2rem;
  text-align: left;
  flex-shrink: 0;
  font-size: 0.28rem;
  color: #202020;
}

.match-loading__icon {
  flex-shrink: 0;
  width: 0.45rem;
  height: 0.45rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.match-loading__icon--pending {
  border: 0.03rem solid #cccccc;
  border-radius: 50%;
}

.match-loading__icon--loading {
  border-radius: 50%;
}

.match-loading__icon--done {
  border-radius: 0;
  background-color: transparent;
}

.match-loading__spinner {
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 50%;
  border: 0.04rem solid rgba(103, 140, 249, 0.15);
  border-top-color: #678cf9;
  box-sizing: border-box;
  animation: match-spin 0.8s linear infinite;
}

.match-loading__check-icon {
  width: 0.45rem;
  height: 0.45rem;
}

@keyframes match-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
